import { render, staticRenderFns } from "./purchaseReturns.vue?vue&type=template&id=4f7d526c"
import script from "./purchaseReturns.vue?vue&type=script&lang=js"
export * from "./purchaseReturns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports